const map = {
  search: {
    title: 'Address...'
  },
};

export default map;
